import React, {useEffect, useState} from "react"
import Navbar from "./Navbar.tsx";
import Markdown from "react-markdown";

const Blog = () => {
    const [data, set_data] = useState("Loading...");
        useEffect(() => {
        // Fetch the .md file from the public folder
        fetch("/markdown/creating_wasm_module.md")
          .then(response => response.text())  // Get the content as text
          .then(data => {
            set_data(data);  // Store it in the state
          })
          .catch(error => console.error('Error fetching .md file:', error));
    }, [])
    return (
        <div>
            <Navbar/>
            <div className="markdown">
                <Markdown>{data}</Markdown>
            </div>
        </div>
    )
}

export default Blog;

